import { Pipe, PipeTransform } from '@angular/core';
import { MethodTypes } from '../interface/interface';
import { UtilsService } from '../utils/utils.service';

@Pipe({
    name: 'nftNames',
    standalone: false
})
export class NftNamesPipe implements PipeTransform {
  constructor(private utils: UtilsService) { }

  transform(nftList: any[], details: any): string {    
    const loanRelatedMethods = [
      MethodTypes.REQ_LOAN,
      MethodTypes.UPDATE_LOAN,
      MethodTypes.ACCEPT_LOAN,
      MethodTypes.CANCEL_LOAN,
      MethodTypes.LOAN_REPAID,
      MethodTypes.FORECLOSE_LOAN,
      MethodTypes.CREATE_ITEM_LOAN_BID,
      MethodTypes.EDIT_ITEM_LOAN_BID,
      MethodTypes.ACCEPT_ITEM_LOAN_BID,
      MethodTypes.CANCEL_ITEM_LOAN_BID,
      MethodTypes.LOAN_DEFAULT,
      MethodTypes.COUNTER_OFFER,
      MethodTypes.RECOUNT_OFFER,
      MethodTypes.BULK_MINT,
      MethodTypes.CREATE_ITEMBID,
      MethodTypes.BORROW_RECOUNT_OFFER,
      MethodTypes.PURCHASE_SELL_ORDER,
      MethodTypes.ACCEPT_ITEMBID,
      MethodTypes.CREATE_SELL_ORDER,
      MethodTypes.ITEM_TRANSFER,
      MethodTypes.COUNTER_OFFER_OPEN_LOAN_BID,
      MethodTypes.CANCEL_SELL_ORDER,
      MethodTypes.CREATE_BULK_LOAN_BID,
      MethodTypes.ACCEPT_BULK_LOAN_BID,
      MethodTypes.CANCEL_BULK_LOAN_BID,
      MethodTypes.EDIT_BULK_LOAN_BID,
      MethodTypes.CANCEL_ITEMBID,
      MethodTypes.PURCHASE_PARTNER_ITEM,
      MethodTypes.SELL_ORDER_CREATED,
      MethodTypes.EDIT_ITEMBID,
      MethodTypes.REPAID_INSTALLMENT,
      MethodTypes.REQUESTEDREFINANCELOAN,
      MethodTypes.ACCEPTEDREFINANCELOAN,
      MethodTypes.UPDATEDREFINANCELOANREQUEST,
      MethodTypes.CANCELLEDREFINANCELOANREQUEST,
      MethodTypes.REQUESTEDLOANSALE,
      MethodTypes.ACCEPTEDLOANSALEREQUEST,
      MethodTypes.BUYERCOUNTEROFFERED,
      MethodTypes.UPDATEDLOANSALEREQUEST,
      MethodTypes.CANCELLEDLOANSALEREQUEST
      

    ];
    if (loanRelatedMethods.includes(details?.method)) return nftList?.map(nft => nft?.name || '-').join(' | ') || '-';
    else return this.utils.getNameFromData(details?.data) || '-';
  }
}
